"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarousel", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarousel;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarousel = require("./useTeachingPopoverCarousel");
const _renderTeachingPopoverCarousel = require("./renderTeachingPopoverCarousel");
const _useTeachingPopoverCarouselStylesstyles = require("./useTeachingPopoverCarouselStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useTeachingPopoverCarouselContextValues = require("./useTeachingPopoverCarouselContextValues");
const TeachingPopoverCarousel = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarousel.useTeachingPopoverCarousel_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselStylesstyles.useTeachingPopoverCarouselStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverCarouselStyles_unstable')(state);
    const contextValues = (0, _useTeachingPopoverCarouselContextValues.useTeachingPopoverCarouselContextValues_unstable)(state);
    return (0, _renderTeachingPopoverCarousel.renderTeachingPopoverCarousel_unstable)(state, contextValues);
});
TeachingPopoverCarousel.displayName = 'TeachingPopoverCarousel';
